import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import logo from "../../assets/images/arabic-english-horizontal-red-box-white-text.png";
import theme from "../../styles/theme";
import { Tooltip as ReactTooltip } from "react-tooltip";

import "../../styles-arabic/header.rtl.css";

function Header() {
  const navigate = useNavigate();
  const handleLogoClick = () => {
    navigate("/");
  };
  const changeLanguage = () => {
    localStorage.setItem("lang", "eng");
    window.location.reload();
  };

  return (
    <div style={{ cursor: "pointer" }}>
      <nav class="navbar">
        <div className="header-logo" onClick={handleLogoClick}>
          <img src={logo} alt="شعار مركز خيرالله" />
        </div>
        <div className="nav-items" dir="rtl">
          <div className="arabic-give-button">
            <a
              className="btn rounded-0"
              style={{ backgroundColor: theme.colors.mainRed }}
              href="https://www.givecampus.com/campaigns/47387/donations/new?a=8830926&designation=089252"
            >
              <span style={{ color: "#FFFFFF" }}> تبرّع </span>&nbsp;&nbsp;
              <FontAwesomeIcon
                style={{ color: "#FFFFFF" }}
                icon={faArrowLeft}
              />
            </a>
          </div>
          <div className="arabic-new-button">
            <button
              className="btn btn btn-outline-dark rounded-0 arabic-corner-button"
              data-tooltip-id="arabic-tooltip"
              onClick={changeLanguage}
            >
              English
            </button>
            <ReactTooltip id="arabic-tooltip" place="bottom" effect="solid" />
          </div>
        </div>
        {/* <div className="arabic-new-button">
          <button
            className="btn btn btn-outline-dark rounded-0 corner-button"
            data-tooltip-id="arabic-tooltip"
            onClick={changeLanguage}
          >
            English
          </button>
          <ReactTooltip id="arabic-tooltip" place="bottom" effect="solid" />
        </div>

        <div className="nav-items">
          <div className="arabic-give-button">
            <a
              className="btn rounded-0"
              style={{ backgroundColor: theme.colors.mainRed }}
              href="https://www.givecampus.com/campaigns/47387/donations/new?a=8830926&designation=089252"
            >
              <FontAwesomeIcon
                style={{ color: "#FFFFFF" }}
                icon={faArrowLeft}
              />
              <span style={{ color: "#FFFFFF" }}> تبرّع </span>&nbsp;&nbsp;
            </a>
          </div>
        </div> */}
      </nav>
    </div>
  );
}

export default Header;
